import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import s from "./medicalCertificate.module.scss";
import { useLocation } from "react-router-dom";
import qrcode from "../../../../../src/images/qr.png"; 
const ViewMedicalCertificate = () => {
  const componentRef = useRef();
  const location = useLocation();
  const data = location.state?.reportData;
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo?.[0] || null;
  const certData = data || {};
  const [pdfHeader, setPdfHeader] = useState(null);
  const [isoLogo, setIsoLogo] = useState(null);
  const [doctorSign, setDoctorSign] = useState(null);
  const [statusStamp, setStatusStamp] = useState(null);

  const toBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(
        `${url}${url.includes("?") ? "&" : "?"}t=${new Date().getTime()}`,
        { mode: "cors" },
      );
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const loadImages = async () => {
      const info = clinic?.hospitalInfo;
      if (info?.pdfHeader) setPdfHeader(await toBase64(info.pdfHeader));
      if (info?.ISOLogo) setIsoLogo(await toBase64(info.ISOLogo));
      const signUrl =
        data?.physicianId?.signature || data?.physicianId?.userId?.signature;
      if (signUrl) setDoctorSign(await toBase64(signUrl));
      const status = data?.medicalStatus;
      let stampUrl = "";

      if (status === "Medically Fit") {
        stampUrl = "https://conferlabdata.s3.us-east-1.amazonaws.com/medicalstatus/FIT-2.png";
      } else if (status === "Medically Unfit") {
        stampUrl =
          "https://conferlabdata.s3.us-east-1.amazonaws.com/medicalstatus/UNFIT-2.png";
      }

      if (stampUrl) {
        const base64Stamp = await toBase64(stampUrl);
        setStatusStamp(base64Stamp);
      }
    };
    loadImages();
  }, [clinic, data]);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Medical_Certificate_${data?.patientId?.UHID || "pt"}`,
  });

  const PageBaseLayout = () => (
    <>
      <div className={s.headerSection}>
        <div className={s.headerLeft}>
          {pdfHeader && (
            <img src={pdfHeader} alt="Logo" className={s.labLogo} />
          )}
          <div className={s.addressText}>
            <strong>{clinic?.clinicName || "SimpleeKare Health"}</strong> <br />
            {clinic?.clinicAddress?.plot && `${clinic.clinicAddress.plot}, `}
            {clinic?.clinicAddress?.area && `${clinic.clinicAddress.area}, `}
            {clinic?.clinicAddress?.city?.name &&
              `${clinic.clinicAddress.city.name}`}{" "}
            <br />
            Contact: {clinic?.phone || "+91-XXXXXXXXXX"}
            <br />
            Website: {clinic?.hospitalInfo?.web_address} <br />
            GSTIN: {clinic?.accountInfo?.gst}
          </div>
        </div>
        <div className={s.headerRight}>
          <div className={s.trustedWrapper}>
            {isoLogo && (
              <img
                src={isoLogo}
                alt="ISO"
                className={s.trustedLogo}
                crossOrigin="anonymous"
              />
            )}
            <div className={s.trustedText}>
              <p className={s.trustedTitle}>Most Trusted Brand</p>
              <div className={s.statBlock}>
                <span className={s.trustedBold}>ISO Certification </span>
                <span className={s.subText}>
                  {clinic?.hospitalInfo?.iso_certificate}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={s.blackline}></div>
      <div className={s.medicalCertTitleBox}>
        <span>MEDICAL CERTIFICATE</span>
      </div>

      <div className={s.patientInfoGrid}>
        <div>
          <strong>Name :</strong> {data?.name || "N/A"}
        </div>
        <div>
          <strong>Date :</strong> {data?.appointmentDate || "N/A"}
        </div>
        <div>
          <strong>Passport No :</strong>{" "}
          {data?.patientId?.userId?.passport || "N/A"}
        </div>
        <div>
          <strong>Wt :</strong> {data?.weight || "N/A"}
        </div>
        <div>
          <strong>D.O.B :</strong>{" "}
          {data?.patientId?.userId?.dob
            ? new Date(data.patientId.userId.dob).toLocaleDateString("en-GB")
            : "N/A"}
        </div>
        <div>
          <strong>UHID No :</strong> {data?.patientId?.UHID || "N/A"}
        </div>
        <div>
          <strong>Project Name :</strong> {data?.projectName || "N/A"}
        </div>
        <div>
          <strong>Ht :</strong> {data?.height || "N/A"}
        </div>
        <div>
          <strong>Age/Sex :</strong>{" "}
          {data?.patientId?.userId?.age?.year || "N/A"} Yrs /{" "}
          {data?.patientId?.userId?.gender || "N/A"}
        </div>
        <div>
          <strong>AppId :</strong> {data?.appointmentId || "N/A"}
        </div>
        <div>
          <strong>For Country :</strong> {data?.nationality || "N/A"}
        </div>
        <div>
          <strong>BMI :</strong> {data?.BMI || "N/A"}
        </div>
        <div>
          <strong>Marital Status :</strong> {data?.maritalStatus}
        </div>
        <div>
          <strong>Ref. By :</strong> {data?.referredBy || "Self"}
        </div>
        <div></div>
        <div></div>
        <div>
          <strong>Post Applied For :</strong> {data?.postAppliedFor || "N/A"}
        </div>
        <div>
          <strong>Religion :</strong> {data?.religion || "N/A"}
        </div>
      </div>
    </>
  );

  return (
    <div className={s.mainWrapper}>
      <div className={`${s.actionBar} no-print`}>
        <div className={s.pageCount}>
          Document: <strong>Medical Certificate</strong>
        </div>
        <button className={s.btnDownload} onClick={handlePrint}>
          Download PDF
        </button>
      </div>

      <div ref={componentRef} className={s.reportPage}>
        <PageBaseLayout />

        <table className={s.reportTable}>
          <thead>
            <tr>
              <th style={{ width: "32%" }}>TYPE OF MEDICAL EXAMINATION</th>
              <th style={{ width: "13%" }}>RESULTS</th>
              <th style={{ width: "40%" }}>TYPE OF LABORATORY INVESTIGATION</th>
              <th style={{ width: "15%" }}>RESULTS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span className={s.categoryTitle}>EYE</span>
                <span className={s.subItem}>R-EYE</span>
                <span className={s.subItem}>L-EYE</span>
                <span className={s.categoryTitle}>EAR</span>
                <span className={s.subItem}>R-EAR</span>
                <span className={s.subItem}>L-EAR</span>
                <span className={s.categoryTitle}>SYSTEMATIC EXAMINATION</span>
                <span className={s.boldSub}>1)CARDIO VASCULAR</span>
                <span className={s.subItem}>BP</span>
                <span className={s.subItem}>PULSE</span>
                <span className={s.subItem}>HEART</span>
                <span className={s.boldSub}>2)RESPIRATORY SYSTEM</span>
                <span className={s.subItem}>THROAT</span>
                <span className={s.subItem}>LUNGS</span>
                <span className={s.boldSub}>3)GASTRO INTESTINAL</span>
                <span className={s.subItem}>ABDOMEN</span>
                <span className={s.boldSub}>4)CNS:</span>
                <span className={s.boldSub}>5)SKIN:</span>
                <span className={s.boldSub}>6)PSYCHATRY</span>
                <span className={s.boldSub}>7)OTHERS</span>
                <span className={s.subItem}>HYDROCELE</span>
                <span className={s.subItem}>HERNIA</span>
                <span className={s.subItem}>VARICOSE VEINS</span>
                <span className={s.subItem}>EXTREMITIES</span>
                <span className={s.subItem}>DEFORMITIES</span>
              </td>

              <td className={s.resultsColumn}>
                <br /> {data?.eye?.r_eye || ""}
                <br /> {data?.eye?.l_eye || ""}
                <br /> <br /> {data?.ear?.r_ear || ""}
                <br /> {data?.ear?.l_ear || ""}
                <br /> <br /> <br />
                {data?.SECV?.BP ? `${data.SECV.BP} mmHg` : ""} <br />
                {data?.SECV?.pulse ? `${data.SECV.pulse} /min` : ""} <br />
                {data?.SECV?.heart || ""} <br />
                <br /> {data?.respiratorySystem?.throat || ""}
                <br /> {data?.respiratorySystem?.lungs || ""}
                <br /> <br /> {data?.gastroIntestinal?.abdomen || ""}
                <br /> {data?.gastroIntestinal?.CNS || ""}
                <br /> {data?.gastroIntestinal?.skin || ""}
                <br /> {data?.gastroIntestinal?.psychatry || ""}
                <br /> <br /> {data?.other?.hydrocele || ""}
                <br /> {data?.other?.hernia || ""}
                <br /> {data?.other?.vericosVeins || ""}
                <br /> {data?.other?.extremities || ""}
                <br /> {data?.other?.deformities || ""}
              </td>

              <td>
                {data?.testDetails?.map((item, idx) => (
                  <div key={`test-name-${idx}`}>
                    {item.tests?.testName || ""}
                  </div>
                ))}

                {data?.radiologyDetails?.map((radio, idx) => (
                  <div key={`radio-name-${idx}`}>
                    {radio.serviceDetails?.testName || radio.testName || ""}
                  </div>
                ))}
              </td>

              <td className={s.resultsColumn}>
                {/* Pathology Results Mapping */}
                {data?.testDetails?.map((item, idx) => (
                  <div
                    key={`test-res-${idx}`}
                    className={
                      item.testResults?.toUpperCase().includes("ABN")
                        ? s.abnormal
                        : s.normal
                    }
                  >
                    {item.testResults || ""}
                  </div>
                ))}

             
                {data?.radiologyDetails?.map((radio, idx) => (
                  <div
                    key={`radio-res-${idx}`}
                    className={
                      radio.radiologyResults?.toUpperCase().includes("ABN")
                        ? s.abnormal
                        : s.normal
                    }
                  >
                    {radio.radiologyResults || ""}
                  </div>
                ))}
              </td>
            </tr>
          </tbody>
        </table>

        <div className={s.findingsSection}>
          <div className={s.findingLeftContent}>
            <div className={s.findingRow}>
              <strong>ABNORMAL FINDING:</strong>{" "}
              {data?.abnormalFindings || "NIL"}
            </div>
            <div className={s.findingRow}>
              <strong>REMARKS:</strong> {data?.remarks || "FIT"}
            </div>

            <div className={s.innerAssets}>
              <div className={s.qrCodeBox}>
                <img src={qrcode} alt="QR" />
              </div>

              <div className={s.fitStamp}>
                {statusStamp ? (
                  <img
                    src={statusStamp}
                    alt={data?.medicalStatus}
                    className={s.stampImg}
                  />
                ) : (
                 
                  <div className={s.stampCircle}>
                    {data?.medicalStatus === "Medically Fit" ? "FIT" : "UNFIT"}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={s.doctorSign}>
            <div className={s.signPlaceholder}>
              {doctorSign ? (
                <img
                  src={doctorSign}
                  alt="Doctor Signature"
                  className={s.signImg}
                />
              ) : (
                <div className={s.noSign}>Signature Not Available</div>
              )}
            </div>

            <div className={s.docName}>
              {data?.physicianId?.userId?.name || "Dr. Archana Dash"}
            </div>

            <div className={s.docDegree}>
              {data?.physicianId?.graduation || ""}
              {data?.physicianId?.registrationNo &&
                `, Reg No: ${data.physicianId.registrationNo}`}
            </div>
          </div>
        </div>

        <div className={s.footerNote}>
          NOTE: All the above reports from the diagnostics centre are attached
          herewith.
        </div>
      </div>
    </div>
  );
};

export default ViewMedicalCertificate;
